// PartBPage5.jsx - Secondary Stage Part B Page 5 (Learner Reflection + Peer Feedback) for HPC Report
import React from 'react';

const PartBPage5 = ({ data }) => {
  const learnerReflection = data?.learner_reflection || {
    awareness: [],
    sensitivity: [],
    creativity: []
  };

  const peerFeedback = data?.peer_feedback || {
    awareness: [],
    sensitivity: [],
    creativity: []
  };

  const learnerReflectionItems = {
    awareness: [
      "I could identify areas where my understanding of the project has improved.",
      "I could explain how my work contributed to the overall project.",
      "I was able to improve the project based on my own and my peers' review."
    ],
    sensitivity: [
      "I was able to build a positive emotional atmosphere within the group.",
      "I could reflect on my strengths and areas for improvement.",
      "I could understand the social relevance of the project."
    ],
    creativity: [
      "I was able to make creative contributions to the project.",
      "I was able to take initiative to complete the project.",
      "I was able to use different materials, tools, and resources during the project."
    ]
  };

  const peerFeedbackItems = {
    awareness: [
      "My peer showed improved understanding of the project.",
      "My peer could explain how her/his work contributed to the overall project.",
      "My peer was able to improve the project based on her/his own and their peers' review."
    ],
    sensitivity: [
      "My peer helped to build a positive emotional atmosphere within the group by valuing everyone's opinions.",
      "My peer could reflect on her/his strengths and areas for improvement.",
      "My peer could understand the social relevance of the project."
    ],
    creativity: [
      "My peer was able to make creative contributions to the project.",
      "My peer was able to take the initiative to help complete the project.",
      "My peer was able to use different materials, tools, and resources during the project."
    ]
  };

  const renderCheckboxSection = (title, items, category, data, bgColor, headerBg) => {
    const checkedIndices = data[category] || [];
    const total = checkedIndices.length;

    return (
      <div style={{ marginBottom: '12px' }}>
        <div style={{
          backgroundColor: headerBg,
          color: '#333',
          padding: '6px 12px',
          fontWeight: 'bold',
          fontSize: '11px',
          marginBottom: '6px'
        }}>
          {title}
        </div>
        <div style={{
          backgroundColor: bgColor,
          padding: '10px'
        }}>
          {items.map((item, index) => (
            <div key={index} style={{
              display: 'flex',
              alignItems: 'flex-start',
              marginBottom: '5px',
              fontSize: '11px',
              lineHeight: '1.3'
            }}>
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid #333',
                marginRight: '8px',
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '1px',
                fontSize: '12px',
                backgroundColor: 'white'
              }}>
                {checkedIndices.includes(index) && '✓'}
              </div>
              <span>{item}</span>
            </div>
          ))}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            marginTop: '8px',
            fontSize: '11px',
            fontWeight: 'bold'
          }}>
            <span style={{ marginRight: '8px' }}>Total number of (✓):</span>
            <div style={{
              width: '32px',
              height: '32px',
              border: '3px solid ' + (headerBg === '#6FA8DC' ? '#4A90A4' : '#DAA520'),
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              fontSize: '13px',
              backgroundColor: 'white'
            }}>
              {total}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="report-page" style={{
      width: '210mm',
      minHeight: '297mm',
      padding: '20mm',
      backgroundColor: 'white',
      boxSizing: 'border-box',
      fontFamily: 'Arial, sans-serif',
      position: 'relative'
    }}>
      {/* Decorative Corners */}
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '0 80px 80px 0',
        borderColor: 'transparent #F4824C transparent transparent'
      }} />

      {/* Header */}
      <div style={{
        backgroundColor: '#F4824C',
        color: 'white',
        fontSize: '14px',
        fontWeight: 'bold',
        padding: '10px',
        textAlign: 'center',
        marginBottom: '16px'
      }}>
        Stage 3
      </div>

      {/* Learner Reflection Section */}
      <div style={{
        backgroundColor: '#4A90A4',
        color: 'white',
        padding: '8px 14px',
        fontWeight: 'bold',
        fontSize: '12px',
        display: 'inline-block',
        marginBottom: '10px'
      }}>
        Learner Reflection
      </div>

      <div style={{
        fontSize: '11px',
        fontWeight: 'bold',
        marginBottom: '10px'
      }}>
        Tick (✓) all statements that apply.
      </div>

      {renderCheckboxSection('Awareness', learnerReflectionItems.awareness, 'awareness', learnerReflection, '#C5E3ED', '#6FA8DC')}
      {renderCheckboxSection('Sensitivity', learnerReflectionItems.sensitivity, 'sensitivity', learnerReflection, '#C5E3ED', '#6FA8DC')}
      {renderCheckboxSection('Creativity', learnerReflectionItems.creativity, 'creativity', learnerReflection, '#C5E3ED', '#6FA8DC')}

      {/* Peer Feedback Section */}
      <div style={{
        backgroundColor: '#DAA520',
        color: 'white',
        padding: '8px 14px',
        fontWeight: 'bold',
        fontSize: '12px',
        display: 'inline-block',
        marginBottom: '10px',
        marginTop: '10px'
      }}>
        Peer Feedback
      </div>

      <div style={{
        fontSize: '11px',
        fontWeight: 'bold',
        marginBottom: '10px'
      }}>
        Tick (✓) all statements that apply.
      </div>

      {renderCheckboxSection('Awareness', peerFeedbackItems.awareness, 'awareness', peerFeedback, '#FFF4CC', '#F4D03F')}
      {renderCheckboxSection('Sensitivity', peerFeedbackItems.sensitivity, 'sensitivity', peerFeedback, '#FFF4CC', '#F4D03F')}
      {renderCheckboxSection('Creativity', peerFeedbackItems.creativity, 'creativity', peerFeedback, '#FFF4CC', '#F4D03F')}

      {/* Page Number */}
      <div style={{
        position: 'absolute',
        bottom: '15mm',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '10px',
        color: '#666',
        fontWeight: 'bold'
      }}>
        16
      </div>

      {/* Bottom decorative corners */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 0 0 60px',
        borderColor: 'transparent transparent transparent #F4824C'
      }} />
      <div style={{
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 60px 0 0',
        borderColor: 'transparent #F4824C transparent transparent',
        opacity: 0.3
      }} />
    </div>
  );
};

export default PartBPage5;
